export enum CalcKindEnum {
    Flow = 'Flow',
    Kvs = 'Kvs',
    Steam = 'Steam',
}
